import { useMemo } from 'react'

import { UAParser } from 'ua-parser-js'

export type DeviceType = 'android' | 'ios' | null

export const useUserDevice = (): {
  deviceType?: DeviceType
  isAndroidDevice: boolean
  isIosDevice: boolean
  isMobileDevice: boolean
} =>
  useMemo(() => {
    const UAparser = new UAParser()
    const os = UAparser.getOS()

    const isAndroidDevice = os.name?.toLowerCase() === 'android'
    const isIosDevice = os.name?.toLowerCase() === 'ios'

    return {
      deviceType: isAndroidDevice ? 'android' : isIosDevice ? 'ios' : null,
      isAndroidDevice,
      isIosDevice,
      isMobileDevice: isAndroidDevice || isIosDevice,
    }
  }, [])
